import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { fetchMemberDashboardSummary, selectMemberDashboardSummary } from "../features/dashboard/member-dashboard.slice";

const useMemberDashboardSummary = () => {
    const dispatch = useAppDispatch();
    const summary = useAppSelector(selectMemberDashboardSummary);

    const getMemberDashboardSummary = async () => {
        await dispatch(fetchMemberDashboardSummary());
    }

    useEffect(() => {
        getMemberDashboardSummary();
    }, []);

    return summary;
}
 
export default useMemberDashboardSummary;